import { useForm } from "../../../hooks/useForm";
import { useGetManagementQuery } from "../../../lib/apollo/graphql/generated";
import Loader from "../../common/components/Loader";
import PageWrapper from "../../common/components/PageWrapper";
import CompanyInfoForm from "../components/CompanyInfoForm";
import PaymentInformation from "../components/PaymentInformation";

export type CompanyInfoFormType = {
  companyName: string;
  address: string;
  copyright: string;
  email: string;
  ceoName: string;
  registrationNumber: string;
  escroRegistration: string;
  phone: string;
  kakaoAddress: string;
  minimumTip: number;
  invitationPoint: number;
  shopAddress: string;
  paymentWarning: string;
  paymentInformation: string;
};
export interface SharedCompanyInfoSectionProps {
  form: CompanyInfoFormType;
  onChange: <K extends keyof CompanyInfoFormType>(
    key: K,
    value: CompanyInfoFormType[K]
  ) => void;
}

export default function CompanyInfoContainer() {
  const [form, onChange, onBatch] = useForm<CompanyInfoFormType>({
    companyName: "",
    address: "",
    copyright: "",
    email: "",
    ceoName: "",
    registrationNumber: "",
    escroRegistration: "",
    phone: "",
    kakaoAddress: "",
    minimumTip: 0,
    invitationPoint: 0,
    shopAddress: "",
    paymentWarning: "",
    paymentInformation: "",
  });

  const { loading } = useGetManagementQuery({
    onCompleted: (res) => {
      const info = res?.getManagement;

      if (!info) {
        return;
      }

      onBatch({
        companyName: info.companyName,
        address: info.address,
        copyright: info.copyright,
        email: info.email,
        ceoName: info.ceoName,
        registrationNumber: info.registrationNumber,
        escroRegistration: info.escroRegistration,
        phone: info.phone,
        kakaoAddress: info.kakaoAddress,
        minimumTip: info?.minimumTip ? +info.minimumTip : 0,
        invitationPoint: info.invitationPoint,
        shopAddress: info.shopAddress,
        paymentWarning: info.paymentWarning || "",
        paymentInformation: info.paymentInformation || "",
      });
    },
  });

  if (loading) {
    return (
      <PageWrapper>
        <Loader />
      </PageWrapper>
    );
  }

  return (
    <PageWrapper className="flex-row gap-1">
      <CompanyInfoForm form={form} onChange={onChange} />
      <PaymentInformation form={form} onChange={onChange} />
    </PageWrapper>
  );
}
